import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import {
  TeamAwareClusterPicker,
  TeamAwareClusterPickerSchema,
} from './TeamAwareClusterPicker';

export const TeamAwareClusterPickerExtension = FormFieldBlueprint.make({
  name: 'TeamAwareClusterPicker',
  params: {
    field: async () =>
      createFormField({
        name: 'TeamAwareClusterPicker',
        component: TeamAwareClusterPicker,
        schema: TeamAwareClusterPickerSchema,
      }),
  },
});
